export default "__VITE_ASSET__CqvjGQTx__"